import type { ITupleRow } from '../RowSection.helpers';

export const TupleRow = ({
	leftLabel,
	leftComponent,
	rightLabel,
	rightComponent,
	noborder,
	adminNote,
	hideLeft,
	hideRight,
	rowClass,
}: ITupleRow) => (
	<div
		className={`transactiondetails_itemrow${noborder ? ' noborder' : ''} border-bottom-dark-navy last-child${rowClass ? ' ' + rowClass : ''}`}
		data-testid='rowsection-tuple'
	>
		<div className='transactiondetails_itemstuple'>
			{!hideLeft && (
				<div className='transactiondetails_item'>
					<label
						htmlFor='amount'
						className='color-primary-50'
					>
						{leftLabel}
					</label>
					{leftComponent}
				</div>
			)}
			{!hideRight && (
				<div className='transactiondetails_item right'>
					<label
						htmlFor='rate'
						className='color-primary-50'
					>
						{rightLabel}
					</label>
					{rightComponent}
				</div>
			)}
		</div>
		{adminNote}
	</div>
);
